import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/** Scrolls to and flashes the element whose data-testid ends with the ?highlight=<id> value (used by global search results). */
export function useHighlightParam(ready = true) {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("highlight");
  useEffect(() => {
    if (!id || !ready) return undefined;
    const timer = setTimeout(() => {
      const target = document.querySelector(`[data-record-id="${id}"]`) || document.querySelector(`[data-testid$="-${id}"]`);
      if (!target) return;
      target.scrollIntoView({ behavior: "smooth", block: "center" });
      target.classList.add("search-highlight");
      setTimeout(() => target.classList.remove("search-highlight"), 4000);
    }, 250);
    return () => clearTimeout(timer);
  }, [id, ready]);
  return id;
}
